const CarbonCreditInvestmentToken = {
  "_format": "hh-sol-artifact-1",
  "contractName": "CarbonCreditInvestmentToken",
  "sourceName": "contracts/core/CarbonCreditInvestmentToken.sol",
  "abi": [
    {
      "inputs": [],
      "name": "ALREADY_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CREDITS_NOT_RECEIVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EXTERNAL_CREDITS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_AMOUNT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_MAX_BATCH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_PREDICTED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_PROJECT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_STAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_TO",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_TOKEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_CREDITS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_CLAIMABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_MATURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_TOKENS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ONCHAIN_CREDITS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKEN_ALREADY_SET",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKEN_NOT_SET",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOO_EARLY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "YEAR_NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensRedeemed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "creditsClaimed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        }
      ],
      "name": "ClaimedCredits",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isERC1155",
          "type": "bool"
        }
      ],
      "name": "CreditTokenConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "CreditsDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CreditsDustSwept",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensRedeemed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "creditsClaimed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        }
      ],
      "name": "ExternalCreditsClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "ExternalCreditsDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "refundReserved",
          "type": "uint256"
        }
      ],
      "name": "Minted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectFailed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensRedeemed",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "name": "RedeemedRefund",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "StageAudited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "maxStageCount",
          "type": "uint8"
        }
      ],
      "name": "StageCountsConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "values",
          "type": "uint256[]"
        }
      ],
      "name": "TransferBatch",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "TransferSingle",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "value",
          "type": "string"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "URI",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        }
      ],
      "name": "YearConfigured",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DECIMALS",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DUST_SWEEP_DELAY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "WAD",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "accounts",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        }
      ],
      "name": "balanceOfBatch",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnForRefund",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "name": "calculateCreditsClaim",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "claim",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "creditsClaimed",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "wasRefund",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "claimStatus",
      "outputs": [
        {
          "internalType": "bool",
          "name": "canClaimCredits",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "canClaimRefund",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        },
        {
          "internalType": "string",
          "name": "status",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "isERC1155",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        }
      ],
      "name": "configureCreditToken",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "yearStageCounts",
          "type": "uint8[]"
        }
      ],
      "name": "configureStageCounts",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        }
      ],
      "name": "configureYear",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "_years",
          "type": "uint8[]"
        },
        {
          "internalType": "uint128[]",
          "name": "predictedCredits",
          "type": "uint128[]"
        }
      ],
      "name": "configureYearBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint128[]",
          "name": "predictedCredits",
          "type": "uint128[]"
        }
      ],
      "name": "configureYearBatchSequential",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "decodeTokenId",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCreditsERC1155",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCreditsERC20",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCreditsExternal",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "encodeTokenId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "exists",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "getExchangeRatePercent",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "getYearClaimState",
      "outputs": [
        {
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "realizedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "circulatingSupply",
          "type": "uint128"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "creditToken",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "creditTokenId",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "isERC1155",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "configured",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "finalized",
          "type": "bool"
        },
        {
          "internalType": "uint128",
          "name": "totalClaimed",
          "type": "uint128"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_project",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_stableCoin",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_maxProjectYear",
          "type": "uint8"
        },
        {
          "internalType": "string",
          "name": "_uri",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "isExternalCredit",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "isStageAudited",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "markProjectFailed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "markStageAudited",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maxProjectYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "refundAmount",
          "type": "uint256"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "refundAmounts",
          "type": "uint256[]"
        }
      ],
      "name": "mintBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "mintBatchProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "project",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectFailed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "redemptionStatus",
      "outputs": [
        {
          "internalType": "bool",
          "name": "canRedeemRevenue",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "canRedeemRefund",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "exchangeRateWad",
          "type": "uint256"
        },
        {
          "internalType": "string",
          "name": "status",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeBatchTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "stageCountForYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stageCountsConfigured",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        }
      ],
      "name": "sweepUnclaimedCredits",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "swept",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "uri",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default CarbonCreditInvestmentToken;
